import React from "react";
import { Colors } from "../../utils/colors";

interface BottomUnderlineViewProps {
  borderRadius: number;
  borderWidth: number;
  borderColor: string;
  children: React.ReactNode;
  width: number;
  height: number;
}

export const BottomUnderlineView: React.FC<BottomUnderlineViewProps> = ({
  borderRadius,
  borderWidth,
  borderColor,
  children,
  width,
  height,
}) => {
  return (
    <div
      style={{
        backgroundColor: Colors.green,
        height: height + borderWidth + borderRadius / 2,
        width: width + borderWidth + borderRadius,
        position: "relative",
      }}>
      <div
        style={{
          position: "absolute",
          top: 1,
          left: 1,
          bottom: 3,
          right: 1,
          borderRadius: borderRadius,
          borderColor: borderColor,
          borderWidth: borderWidth,
          borderStyle: "solid",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: borderWidth + borderRadius / 1.5,
          backgroundColor: Colors.green,
        }}>
        <div
          style={{
            margin: "0 auto",
            width: width,
            height: height,
          }}>
          {children}
        </div>
      </div>
    </div>
  );
};
